import styles from './HundredsChart.module.css';

export interface HundredsChartProps {
  /** First day in the chart (1-based). Default 1; ranges step by 100. */
  rangeStart: number;
  /** Currently marked day numbers. */
  markedDays: ReadonlySet<number>;
  /** Toggle handler. */
  onToggle: (day: number) => void;
}

/**
 * 10×10 cell grid covering [rangeStart, rangeStart + 99]. Each cell is a
 * touch target ≥ var(--token-touch-min). Marked cells get the accent
 * color; the cell label is the day number.
 */
export function HundredsChart({ rangeStart, markedDays, onToggle }: HundredsChartProps) {
  const cells: number[] = [];
  for (let i = 0; i < 100; i++) cells.push(rangeStart + i);

  return (
    <div className={styles.grid} role="grid" data-testid="hundreds-chart">
      {cells.map((n) => {
        const isMarked = markedDays.has(n);
        return (
          <button
            key={n}
            type="button"
            role="gridcell"
            onClick={() => onToggle(n)}
            className={styles.cell}
            data-testid="hundreds-cell"
            data-day={n}
            data-marked={isMarked}
            aria-pressed={isMarked}
          >
            {n}
          </button>
        );
      })}
    </div>
  );
}
